import React from "react";

import defaultStyle from "./SimpleLayoutView.module.scss";

export interface SimpleLayoutCoreOptions {}

export interface SimpleLayoutProps extends SimpleLayoutCoreOptions {
  children: React.ReactNode;
  style?: Record<string, string>;
}

export const SimpleLayoutView: React.FC<SimpleLayoutProps> = (props: SimpleLayoutProps) => {
  const { style = defaultStyle } = props;
  return <div className={style.root}>{props.children}</div>;
};
